module.exports = "<div class=\"super-admin-container\" id=\"super-admin-main-container\">\r\n  <div class=\"page-swapper-super-admin page-swapper\">\r\n    <app-super-admin-access (displayHome)=\"displayHome()\"></app-super-admin-access>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/super-admin/super-admin.component.html
// module id = ../../../../../src/app/core/components/training-management/super-admin/super-admin.component.html
// module chunks = main